import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// TODO: This util function is copied in strata/src/libs/utils.ts. Combine and update references in strata

// Fixes issue with custom typography sizes not being recognized
// Example: strata:text-color-gray-900 and strata:text-title-micro couldn't be merged together
const customTwMerge = extendTailwindMerge({
  prefix: 'strata',
  extend: {
    classGroups: {
      // Custom typography sizes - separate from text colors
      'font-size': [
        {
          text: [
            'title-4xl',
            'title-3xl',
            'title-2xl',
            'title-xl',
            'title-lg',
            'title-base',
            'title-sm',
            'title-xs',
            'title-tiny',
            'title-micro',
            'body-xl',
            'body-lg',
            'body-base',
            'body-sm',
            'body-xs',
            'body-tiny',
          ],
        },
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]): string {
  return customTwMerge(clsx(inputs))
}
